import { useState } from "react";
import axios from "axios";
import styles from "./styles.module.css";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const res = await axios.post(`${apiUrl}/api/auth/forgot-password`, { email });
            setMessage(res.data.message);
            setError("");
        } catch (err) {
            setError(err.response?.data?.error || "Bir hata oluştu");
            setMessage("");
        }
    };

    return (
        <div className={styles.login_container}>
            <form className={styles.form_container} onSubmit={handleSubmit}>
                <h1>Şifreni mi unuttun?</h1>
                <input
                    type="email"
                    placeholder="Email adresinizi girin"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    className={styles.input}
                />
                {message && <div className={styles.success_msg}>{message}</div>}
                {error && <div className={styles.error_msg}>{error}</div>}
                <button type="submit" className={styles.green_btn}>
                    Şifre Sıfırlama Linki Gönder
                </button>
            </form>
        </div>
    );
};

export default ForgotPassword;
